import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import WallCalendar from './WallCalendar';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <WallCalendar />
  </React.StrictMode>
);
